module.exports = __webpack_public_path__ + "app-bar.png?5244a8cfdf8075cf8bb531a8988ea8e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-bar.png
// module id = 854
// module chunks = 0